import { z } from 'zod'

export const phoneNumberSchema = z.string().transform((p, ctx) => {
  if (/[^0-9]/.test(p)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Only numbers are allowed',
    })
    return p
  }
  const stripped = p.replace(/[^\d]/g, '')
  if (!stripped) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Phone number is required',
    })
    return p
  }
  // we expect 10 digits without the country code
  if (stripped.length !== 10) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Invalid phone number',
    })
    return p
  }
  return stripped ? `+1${stripped}` : stripped
})

export const phoneNumberSchemaOnboarding = z.string().transform((p, ctx) => {
  const stripped = p.replace(/[^\d]/g, '')
  if (!stripped) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Phone number is required',
    })
    return stripped
  }
  // we expect 10 digits without the country code
  if (stripped.length !== 10) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Invalid phone number',
    })
    return p
  }
  return stripped ? `+1${stripped}` : stripped
})
